import { ItemType } from '@vista-digital/ocapi-types/v1';
import { getDefaultItemPrice } from '../../..';
import { getLowestItemPrice } from '../../../sales-data/utils/items/item-price-utils';
import { getInProgressItem } from '../../selectors/items/get-in-progress-item';
import { updateParentSalesItemOption } from '../../utils/items/update-parent-sales-item-option';
export const updateInProgressParentSalesItemOption = (option, quantity) => {
    const inProgressItem = getInProgressItem();
    if ((inProgressItem === null || inProgressItem === void 0 ? void 0 : inProgressItem.type) !== ItemType.ParentSales) {
        throw new Error('Cannot update in-progress item options without an in-progress parent sales item.');
    }
    const lowestOptionPrice = getLowestItemPrice(option.prices);
    updateParentSalesItemOption(inProgressItem, option.itemId, quantity, lowestOptionPrice || getDefaultItemPrice(option.prices));
};
